import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { IUnifiedScore } from '@app/core/models/customer.model';
import { AppFacade } from '@app/facades/app.facade';

@Component({
  selector: 'layout-no-available-offer',
  templateUrl: './no-available-offer.component.html',
  styleUrls: ['./no-available-offer.component.scss'],
})
export class NoAvailableOfferComponent implements OnInit, AfterViewInit {
  @Input() score: IUnifiedScore;
  @Input() isCustomer: boolean;
  @Output() closeNoOfferErrorEvent = new EventEmitter<boolean>();
  @Output() redirectToServicingPortalEvent = new EventEmitter<boolean>();

  public installments: any[] = [];

  constructor(private _appFacade: AppFacade) {}

  ngOnInit(): void {
    this._appFacade.killPurchaseWithoutRedirect();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.score) {
      this.setUpInstallments(this.score);
    }
  }

  ngAfterViewInit(): void {}

  public setUpInstallments(score: IUnifiedScore): void {
    for (const key in score.others) {
      const installment = key.replace('month_', '');
      this.installments.push({
        number: installment,
        amount: score.others[key],
      });
    }
    this.installments.sort((a, b) => parseInt(a.months) - parseInt(b.months));
  }

  public onCloseNoOfferError() {
    this.closeNoOfferErrorEvent.emit(true);
  }

  public onRedirectToServicingPortal() {
    this.redirectToServicingPortalEvent.emit(true);
  }
}
